<template>
  <TournamentsList
    :data-source="getCompetitionsAction"
    :query-params="competitionsQuery"
    :item-width="3"
    dummy-position="center"
    dummy-icon="empty-competitions"
    :dummy-text="
      $$t('There are so many competions await for you', 'no-results_subheader')
    "
  />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import TournamentsList from '@/components/common/TournamentsList';
import { translate } from '@/mixins/translate';

export default {
  name: 'AccountCompetitionsClan',
  components: {
    TournamentsList,
  },
  mixins: [translate('_web_account_competitions_list')],
  data() {
    return {};
  },
  computed: {
    ...mapState('current', ['accountId']),
    competitionsQuery() {
      return {
        player: this.accountId,
      };
    },
  },
  created() {},
  methods: {
    ...mapActions(['getCompetitionsAction']),
  },
};
</script>
